import "core-js/modules/es.array.includes.js";
/**
 * POC Store Context - Contextualisation bouton RDV
 * POC fin prévue : 31/08/2026 - Code à supprimer après cette date
 *
 * Magasins éligibles au POC (prise de RDV directe)
 */

import STORE_ID_TO_SLUG from './stores.json';
export var POC_ELIGIBLE_STORE_IDS = ['49', '156', '37', '151', '173'];

/**
 * Vérifie si un magasin est éligible au POC
 * @param {string} storeId - ID du magasin
 * @returns {boolean}
 */
export function isStorePocEligible(storeId) {
  return POC_ELIGIBLE_STORE_IDS.includes(String(storeId));
}

/**
 * Retourne l'URL de la fiche magasin
 * @param {string} storeId - ID du magasin
 * @returns {string|null} URL de la fiche magasin ou null si non trouvé
 */
export function getStorePageUrl(storeId) {
  var slug = STORE_ID_TO_SLUG[String(storeId)];
  return slug ? "/magasins/".concat(slug, ".html") : null;
}